import { type ReactNode } from "react"
import { cn } from "~/utils/helpers"

type PageFillProps = {
  children: ReactNode
  className?: string
}

/**
 * Layout primitive — bounded flex column for a single full-height child.
 * Canonical intent: {@link ../intents.ts PAGE_FILL_INTENT}.
 * Approved surface: design-system/APPROVED.md.
 */
const PageFill = ({ children, className }: PageFillProps) => {
  return <div className={cn("flex-1 min-h-0 min-w-0 flex flex-col", className)}>{children}</div>
}

export default PageFill
